import PropTypes from 'prop-types';
import React from 'react';

export const BounceWrapper = ({ softOrder, Component, ...rest }) => {
  const details = {
    tacticName: 'BOUNCE',
    category: 'Setup',
    type: 'Bounce',
    domain: 'Underlying',
  };
  const priceToBreak = softOrder.priceToBreak;

  return <Component details={details} priceToBreak={priceToBreak} {...rest}/>;
};

BounceWrapper.propTypes = {
  Component: PropTypes.any,
  softOrder: PropTypes.shape({
    priceToBreak: PropTypes.any
  })
};


